import { useTranslation } from "react-i18next";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import LastServiceCard from "./LastServiceCard";

const LastServicesList = ({ services, deviceUuid, update }) => {
  const { t } = useTranslation();

  if (!deviceUuid) return null;

  if (update) {
    return <div className="empty-state"></div>;
  }
  if (services.length === 0) {
    return (
      <div style={{ height: "100%" }}>
        {" "}
        <BMXSeparator
          title={t("global:service.lastServices")}
          children={
            <span
              style={{ cursor: "pointer" }}
              onClick={() => goToDevice(deviceUuid)}
            >
              {t("global:service.showMoreAboutDevice")}
            </span>
          }
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
          }}
          className="empty-state"
        >
          Brak wcześniejszych zleceń serwisów dla tego urządzenia
        </div>
      </div>
    );
  }
  const goToDevice = (uuid) => {
    if (uuid) {
      let origin = window.location.origin;
      origin += `/#/dashboard/device/${uuid}`;
      window.open(origin, "_blank", "noreferrer");
    }
  };

  return (
    <>
      <div style={{ marginBottom: "30px" }}>
        <BMXSeparator
          title={t("global:service.lastServices")}
          children={
            <span
              style={{ cursor: "pointer" }}
              onClick={() => goToDevice(deviceUuid)}
            >
              {t("global:service.showMoreAboutDevice")}
            </span>
          }
        />
      </div>

      {services.map((service, index) => (
        <LastServiceCard
          key={service.uuid}
          service={service}
          isFirst={index === 0}
        />
      ))}
    </>
  );
};

export default LastServicesList;
